<template>
    <small class="d-block form-text text-muted"><slot></slot></small>
</template>

<script>
    export default {
        name: 'input-hint'
    }
</script>